import { useEffect, useRef, forwardRef, useImperativeHandle } from "react";
import FGField from "./FGField";
import classNames from "classnames";

export type TFGInputProps = JSX.IntrinsicElements["input"] & {
  label: string|JSX.Element|JSX.Element[];
  desc?: string|JSX.Element|JSX.Element[];
  /** just keep toggling this value will autofocus the element */
  triggerFocus?: boolean;
  /** defaults to "inset" */
  variant?: "normal" | "inset";
};

/** @see `<FGField/>` */
const FGInput = forwardRef<HTMLInputElement, TFGInputProps>((props, ref) => {
  const refInner = useRef<HTMLInputElement>();
  useImperativeHandle(ref, () => refInner.current);

  useEffect(() => {
    if (typeof props.triggerFocus !== "undefined") {
      setTimeout(() => (refInner.current && refInner.current.focus()), 50);
    }
  }, [props.triggerFocus]);

  const newProps = {...props};
  delete newProps.variant;
  delete newProps.triggerFocus;

  return <FGField name={props.name} label={props.label} desc={props.desc} comp="FGInput"
    required={props.required}
    className={classNames([
      "fg__input",
      {"fg__control--normal": props.variant === "normal"}
    ])}
  >
    <input
      ref={refInner}
      type={props.type ?? "text"}
      id={props.name}
      {...newProps}
    />
  </FGField>;
});

export default FGInput;
